import { createStore, applyMiddleware, combineReducers } from "redux";
import thunkMiddleware from "redux-thunk";
import { TypedUseSelectorHook, useSelector } from "react-redux";
import { composeWithDevTools } from "redux-devtools-extension";

import * as reducers from "app/store/Reducers";
import { RootState } from "./InitialState";

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default function createAppStore(initialState: RootState) {
  const finalCreateStore = composeWithDevTools(
    applyMiddleware(thunkMiddleware)
  )(createStore);

  return finalCreateStore(
    combineReducers({
      ...reducers
    }),
    initialState
  );
}
